<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
    <v-card>
      <v-card-title>
        Cuentas Bancarias
      </v-card-title>


      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          size="128"
          width="4"
          class="mb-3"
          color="primary"
        ></v-progress-circular>
        <div class="text-subtitle-2">
          Cargando detalles del proveedor ...
        </div>
      </v-card-text>

      <v-card-text v-else>
        <v-row class="pa-0 ma-0">          
          <v-col cols="4">
            <div class="text-subtitle-2">Nombre comercial:</div>
            <div>{{ proveedor.nombre_completo }}</div>
          </v-col>

          <v-col cols="4">
            <div class="text-subtitle-2">Nombre del Contacto:</div>
            <div>{{ proveedor.nombre_contacto }}</div>
          </v-col>

          <v-col cols="4">
            <div class="text-subtitle-2">Teléfono Empresarial/Sucursal:</div>
            <div>{{ proveedor.telefono }}</div>
          </v-col>

          <v-col cols="6">
            <div class="text-subtitle-2">Correo Electrónico:</div>
            <div>{{ proveedor.email_contacto }}</div>
          </v-col>

          <v-col cols="6" v-if="proveedor.clave">
            <div class="text-subtitle-2">Clave:</div>
            <div>{{ proveedor.clave }}</div>
          </v-col>
        </v-row>

        <!-- Cuentas Nacionales -->
        <v-row v-if="proveedor.id_proveedor_tipo == 'b1921daf-3922-47ad-8a80-33a0299babe5'">
          <v-col cols="12">
            <nacionales
              :id_proveedor="proveedor.id_proveedor"
              @change="getLogs(proveedor.id_proveedor)"
            ></nacionales>
          </v-col>
        </v-row>

        <!-- Cuentas Internacionales -->
        <v-row v-if="proveedor.id_proveedor_tipo == '733d857a-5692-40d7-b47c-dd0c70da0394'">
          <v-col cols="12">
            <internacionales
                :id_proveedor="proveedor.id_proveedor"
                @change="getLogs(proveedor.id_proveedor)"
            ></internacionales>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0 mb-0 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon>mdi-history</v-icon>
              Información de Auditoría
            </div>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="logs"
              dense
              :items-per-page="10"
              class="elevation-1"
            >
              <!-- Columna de icono/estado -->
              <template v-slot:[`item.icon`]="{ item }">
                <v-icon small :color="getColor(item.mensaje)">
                  {{ getIcon(item.mensaje) }}
                </v-icon>
              </template>

              <!-- Columna de fecha más compacta -->
              <template v-slot:[`item.fecha`]="{ item }">
                <span class="text-caption grey--text">{{ item.fecha }}</span>
              </template>

              <!-- Columna de usuario con chip -->
              <template v-slot:[`item.usuario`]="{ item }">
                <v-chip
                  x-small
                  label
                  :color="item.usuario.includes('Automatico') ? 'grey lighten-2' : 'blue lighten-4'"
                >
                  {{ item.usuario }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="close" :disabled="loading">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import Nacionales from './Nacionales.vue';
import Internacionales from './Internacionales.vue';

export default {
  name: 'ProveedorDetalleDialog',

  components: {
    Nacionales,
    Internacionales
  },
  
  data() {
    return {
      dialog: false,
      loading: false,
      proveedor: {
        // Proveedor
        id_proveedor: null,
        id_proveedor_nivel: null,
        nombre_proveedor_nivel: '',
        id_proveedor_tipo: null,
        nombre_proveedor_tipo: '',
        id_persona_tipo: null,
        nombre_persona_tipo: '',
        rfc: '',
        id_proveedor_actividad: null,
        nombre_proveedor_actividad: '',
        clave: '',
        nombre_completo: '',
        nombre_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
        bloqueado: false,
        bloqueo_definitivo: false,
        bloqueo_motivo: '',
        fecha_bloqueo: '',
        usuario_bloqueo: '',
        // Proveedor Fiscal
        calle: '',
        num_ext: '',
        num_int: '',
        // Datos Fiscales Nacionales
        razon_social: '',
        id_estado: null,
        nombre_estado: '',
        id_municipio: null,
        nombre_municipio: '',
        id_regimen_fiscal: null,
        nombre_regimen_fiscal: '',
        codigo_postal: '',
        localidad: '',
        colonia: '',
        // Datos Fiscales Internacionales
        numero_fiscal: '',
        ciudad: '',
        region: '',
        id_pais: null,
        nombre_pais: '',
        telefono: '',
        // Usuarios
        ultima_actualizacion: '',
        usuario_actualizo: '',
        validado: false,
        usuario_valido: '',
        fecha_valido: ''
      },
      defaultProveedor: {
        // Proveedor
        id_proveedor: null,
        id_proveedor_nivel: null,
        nombre_proveedor_nivel: '',
        id_proveedor_tipo: null,
        nombre_proveedor_tipo: '',
        id_persona_tipo: null,
        nombre_persona_tipo: '',
        rfc: '',
        id_proveedor_actividad: null,
        nombre_proveedor_actividad: '',
        clave: '',
        nombre_completo: '',
        nombre_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
        bloqueado: false,
        bloqueo_definitivo: false,
        bloqueo_motivo: '',
        fecha_bloqueo: '',
        usuario_bloqueo: '',
        // Proveedor Fiscal
        calle: '',
        num_ext: '',
        num_int: '',
        // Datos Fiscales Nacionales
        razon_social: '',
        id_estado: null,
        nombre_estado: '',
        id_municipio: null,
        nombre_municipio: '',
        id_regimen_fiscal: null,
        nombre_regimen_fiscal: '',
        codigo_postal: '',
        localidad: '',
        colonia: '',
        // Datos Fiscales Internacionales
        numero_fiscal: '',
        ciudad: '',
        region: '',
        id_pais: null,
        nombre_pais: '',
        telefono: '',
        // Usuarios
        ultima_actualizacion: '',
        usuario_actualizo: '',
        validado: false,
        usuario_valido: '',
        fecha_valido: ''
      },
      logs: [],
      headers: [
        { text: '', value: 'icon', width: '50px', sortable: false },
        { text: 'Fecha', value: 'fecha', width: '140px' },
        { text: 'Usuario', value: 'usuario', width: '200px' },
        { text: 'Acción', value: 'mensaje' }
      ],
    };
  },

  methods: {
    async open(id_proveedor) {
      this.dialog = true;
      this.loading = true;
      this.proveedor = Object.assign({}, this.defaultProveedor);
      this.logs = [];

      try {
        // Primera petición: obtener los detalles del proveedor
        const proveedorResponse = await axios.get(`/Proveedores/DetallesProveedor/${id_proveedor}`);
        this.proveedor = proveedorResponse.data;

        await this.getLogs(this.proveedor.id_proveedor);

      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getLogs(id_proveedor){
      // Segunda petición: depende de algún dato del proveedor
      // Ejemplo: obtener logs específicos basados en el tipo de proveedor o algún ID relacionado
      const logsResponse = await axios.get(this.proveedor.id_proveedor_tipo == 'b1921daf-3922-47ad-8a80-33a0299babe5' ? `/Proveedores/ListarProveedorCuentaNacionalCambios/${id_proveedor}` : `/Proveedores/ListarProveedorCuentaInternacionalCambios/${id_proveedor}` );
      this.logs = logsResponse.data;
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.proveedor = Object.assign({}, this.defaultProveedor);
      this.logs = [];
    },
    getIcon(mensaje) {
      if (mensaje.includes('Validó')) return 'mdi-check-circle'
      if (mensaje.includes('Invalidó')) return 'mdi-close-circle'
      if (mensaje.includes('Registró')) return 'mdi-plus-circle'
      if (mensaje.includes('Asignó')) return 'mdi-tag-plus'
      if (mensaje.includes('Actualizó')) return 'mdi-pencil-circle'
      if (mensaje.includes('Eliminó')) return 'mdi-delete-circle'
      if (mensaje.includes('Dio de baja')) return 'mdi-delete-circle'
      return 'mdi-information'
    },
    getColor(mensaje) {
      if (mensaje.includes('Validó')) return 'success'
      if (mensaje.includes('Invalidó')) return 'warning'
      if (mensaje.includes('Registró')) return 'primary'
      if (mensaje.includes('Asignó')) return 'info'
      if (mensaje.includes('Actualizó')) return 'blue'
      if (mensaje.includes('Eliminó')) return 'error'
      if (mensaje.includes('Dio de baja')) return 'error'
      return 'grey'
    }
  }
};
</script>